export const API_URL = window.location.hostname.includes("sashachisler")
  ? 'https://api.sashachisler.com'
  : 'http://127.0.0.1:5000'; 